import { ResponsiveTableConfiguration, TableLayout } from '@spartacus/storefront'

export const DEFAULT_TABLE_STRUCTURE: ResponsiveTableConfiguration = {
  options: { layout: TableLayout.VERTICAL_STACKED },
  lg: { options: { layout: TableLayout.VERTICAL } }
}
